require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./los-cuatro-caballos-negros-de-la-uefa-champions-league.json") })
        }
      }, "path---los-cuatro-caballos-negros-de-la-uefa-champions-league");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---los-cuatro-caballos-negros-de-la-uefa-champions-league!./.cache/json/los-cuatro-caballos-negros-de-la-uefa-champions-league.json
// module id = 453
// module chunks = 231608221292675